import { BankerRepoImpl } from "domain/repository/Banker/BankerRepoImpl";
import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { LetPassAccountRepoImpl } from "domain/repository/LetPassAccount/LetPassAccountRepoImpl";
import { useLetPassAccountTracked } from "presentation/store/LetPassAccount/LetPassAccountProvider";
import { LetPassAccountVM } from "presentation/viewModel/LetPassAccount/LetPassAccountVM";
import { useMemo } from "react";

export const useLetPassAccountVM = () => {
    const [, setLetPassAccountState] = useLetPassAccountTracked();
    const letPassAccountVM = useMemo(() =>
        LetPassAccountVM({
            dispatch: [setLetPassAccountState],
            repo: LetPassAccountRepoImpl(),
            companyRepo: CompanyRepoImpl(),
            bankerRepo: BankerRepoImpl(),
        }), [setLetPassAccountState])

    return letPassAccountVM
}